var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import * as React from 'react';
import { useIntersectionObserver } from '../use-intersection-observer';
import { ITrackType, useClickstreamAnalytics } from '../clickstream-analytics-context';
import { IntersectionTrackerTags, referrerMapper } from './util';
import { uisMicroMessagesAggregator } from './util';
export var IntersectionTracker = function (_a) {
    var _b;
    var referrerId = _a.referrerId, linkName = _a.linkName, additionalUisPrimeMicroMessages = _a.additionalUisPrimeMicroMessages, delay = _a.delay, className = _a.className, _c = _a.trackOnce, trackOnce = _c === void 0 ? true : _c, intersectionOptions = _a.intersectionOptions, tag = _a.tag, deps = _a.deps, cloneElement = _a.cloneElement, _d = _a.refAttrForCloneElement, refAttrForCloneElement = _d === void 0 ? 'ref' : _d, children = _a.children;
    var track = useClickstreamAnalytics().track;
    var _e = __read(useIntersectionObserver(function (entries, intersection) {
        var _a = __read(entries, 1), entry = _a[0];
        if (entry.isIntersecting) {
            track(ITrackType.EVENT, {
                data: uisMicroMessagesAggregator(referrerMapper(referrerId, linkName, 'impression'), additionalUisPrimeMicroMessages),
                config: { delay: delay }
            });
            if (trackOnce) {
                intersection.disconnect();
            }
        }
    }, intersectionOptions, deps), 1), setRef = _e[0];
    if (!children) {
        return null;
    }
    if (cloneElement) {
        var childrenArray = React.Children.toArray(children);
        var firstChild = childrenArray[0];
        return React.cloneElement(firstChild, (_b = {},
            _b[refAttrForCloneElement] = setRef,
            _b.className = className,
            _b));
    }
    var Tag = ((tag && IntersectionTrackerTags.get(tag)) ||
        IntersectionTrackerTags.get('div'));
    return (React.createElement(Tag, { ref: setRef, className: className }, children));
};
IntersectionTracker.displayName = 'IntersectionTracker';
//# sourceMappingURL=intersection-tracker.js.map